export default "__VITE_ASSET__kGUsPXZI__"